<template>
  <div>
    <div style="position:relative; height:100vh;">
      <div style="position:absolute; top:0; left:0; width:100%; height:100%; display:flex; align-items:center; justify-content:center; ">
        <a class="button button--white-filled" @click.stop.prevent="login__clicked">Login With Gmail</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    login__clicked(){
      this.$store.dispatch('gmailSignIn');
    }
  }
}
</script>
